/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TaskInsert/view.blocks to change it.
import Description from './Description/index'
import DocumentTemplate from './DocumentTemplate/index'
import HelpText from './HelpText/index'
import React from 'react'
import TaskBasket from './TaskBasket/index'
import Title from './Title/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TaskInsert({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/TaskInsert"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="TaskInsert.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<HelpText
  viewPath={`${viewPath}/HelpText`}
/>
<Title
  viewPath={`${viewPath}/Title`}
/>
<Description
  viewPath={`${viewPath}/Description`}
/>
<TaskBasket
  viewPath={`${viewPath}/TaskBasket`}
/>
<DocumentTemplate
  viewPath={`${viewPath}/DocumentTemplate`}
/>
</div>
{children}
</React.Fragment>)
}